import Step from './step';
import {createElement} from 'methods/utils';

function NotificationStep(modal, options = {}) {
    const className = 'NotificationStep';
    const $element = createElement(
        `<div class="${className}">
            <div class="${className}__wrapper">
                <div class="${className}__description js-description"></div>
            </div>
        </div>`
    );

    Step.call(this, modal, $element, options);

    this.canPrevStep = false;

    this.$description = this.$element.querySelector('.js-description');
    this.$description.textContent = this.options.description;
}

NotificationStep.prototype = Object.create(Step.prototype);
Object.defineProperty(NotificationStep.prototype, 'constructor', {
    value: NotificationStep,
    enumerable: false,
    writable: true,
});

NotificationStep.prototype.setOptions = function(options) {
    Step.prototype.setOptions.call(this, Object.assign({
        title: '',
        description: '',
    }, options));
}

NotificationStep.prototype.show = function() {
    this.modal.setTitle(this.options.title);
    this.modal.setCanPrevStep(this.canPrevStep);
}

export default NotificationStep;
